import Checkbox from "@material-ui/core/Checkbox";
import classnames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import warningIcon from "../../documentList/warning.svg";
import { State } from "../../state";
import { formatMoneyValue } from "../../utils/formatters";
import {
  AccountPresenter,
  DocumentExceptionsInfo
} from "../model/presenter/types";
import { selectCell as selectCellAction } from "../model/selectedCells/actions";
import {
  DocExceptionParams,
  EXCEPTION_STATE,
  updateDocumentExceptionState as updateDocumentExceptionStateAction,
  UpdateDocumentExceptionStateActionType
} from "../model/spread/actions";
import { getLanguage, getSpread } from "../model/spread/selector";
import { Spread } from "../model/spread/types";
import "./ErrorFlyout.scss";
import "./Flyout.scss";

interface ErrorFlyoutBaseProps {
  account: AccountPresenter;
  periodIndex: number;
  selectCell: typeof selectCellAction;
  documentException: DocumentExceptionsInfo;
}

interface ErrorFlyoutProps extends ErrorFlyoutBaseProps {
  updateDocumentExceptionState: UpdateDocumentExceptionStateActionType;
  spreadId: string | undefined;
  spread?: Spread;
  language?: string | null;
}

interface ErrorFlyoutState {
  resolved: boolean;
}

class ErrorFlyout extends React.Component<ErrorFlyoutProps, ErrorFlyoutState> {
  constructor(props: ErrorFlyoutProps) {
    super(props);

    this.state = {
      resolved: props.documentException.disabled
    };
  }

  public markResolved = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { spreadId, documentException } = this.props;
    if (spreadId) {
      this.setState({ resolved: event.target.checked });
      const params: DocExceptionParams = {
        spreadId,
        documentExceptionId: documentException.exceptionId,
        state: documentException.disabled
          ? EXCEPTION_STATE.ACTIVATE
          : EXCEPTION_STATE.DEACTIVATE
      };

      this.props.updateDocumentExceptionState(params);
    }
  };

  public selectCorrespondingCell = (
    event: React.MouseEvent<HTMLTableCellElement>
  ) => {
    const { account, periodIndex } = this.props;
    this.props.selectCell({
      period: periodIndex,
      account
    });
    event.stopPropagation();
  };

  public render() {
    const { account, documentException, periodIndex } = this.props;

    const calculatedValue = account.periodValues[periodIndex] || 0;
    const reportedValue = documentException.valueAsReported;
    const valueNotReadException = documentException.type === "PDF_READ_ERROR";

    let difference;
    let differenceValue;

    if (reportedValue && !valueNotReadException) {
      difference = calculatedValue - reportedValue;
      differenceValue = formatMoneyValue(difference);
    }

    const language = this.props.language;
    const name =
      (language &&
        account.translatedNames &&
        account.translatedNames[language]) ||
      account.name;

    return (
      <div className="Flyout">
        <div className="Flyout__arrow" />
        <div
          className="Flyout__content"
          onMouseDown={this.selectCorrespondingCell}
        >
          <div className="Flyout__header">{name.toUpperCase()}</div>
          <div className="Flyout__data Flyout__data--no-padding">
            <div className="ErrorFlyout__data-row">
              <span className="ErrorFlyout__calculated">
                {documentException.period} Calculated:
              </span>
              <span className="ErrorFlyout__value">
                {formatMoneyValue(calculatedValue)}
              </span>
            </div>
            <div className="ErrorFlyout__data-row">
              <span
                className={classnames("ErrorFlyout__reported", {
                  "ErrorFlyout__value--unreported": valueNotReadException
                })}
              >
                {documentException.period} Reported:
              </span>
              <span
                className={classnames("ErrorFlyout__value", {
                  "ErrorFlyout__value--unreported": valueNotReadException
                })}
              >
                {valueNotReadException
                  ? "unread"
                  : reportedValue && formatMoneyValue(reportedValue)}
              </span>
            </div>
            {differenceValue ? (
              <div className="ErrorFlyout__difference">
                <span className="ErrorFlyout__difference-header">
                  Difference:{" "}
                </span>
                <span className="ErrorFlyout__difference-value">
                  {differenceValue}
                </span>
              </div>
            ) : null}
            <hr className="Flyout__divider" />
            {valueNotReadException ? (
              <React.Fragment>
                <div className="ErrorFlyout__failed">
                  <img className="ErrorFlyout__failed-icon" src={warningIcon} />
                  <div className="ErrorFlyout__failed-text">
                    reported value not read, <br /> please review against PDF.
                  </div>
                </div>
                <hr className="Flyout__divider" />
              </React.Fragment>
            ) : null}
          </div>
          <div className="ErrorFlyout__mark-as-resolve">
            <Checkbox
              id="markResolved"
              color="default"
              checked={this.state.resolved}
              onChange={this.markResolved}
              disabled={this.props.spread && this.props.spread.exceptionLoading}
            />
            <label
              htmlFor="markResolved"
              className="ErrorFlyout__mark-as-resolve-text"
            >
              Mark as resolved
            </label>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: State, ownProps: ErrorFlyoutBaseProps) => {
  const spread = getSpread(state);
  return {
    spreadId: spread && spread.id,
    spread,
    language: getLanguage(state)
  };
};

export default connect(
  mapStateToProps,
  { updateDocumentExceptionState: updateDocumentExceptionStateAction.action }
)(ErrorFlyout);

export { ErrorFlyout };



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/ErrorFlyout.tsx